import React, { useLayoutEffect } from 'react';
import Background from '../../../assets/Images/png/bg-new-password.svg';
import ChangepasswordForm from './ChangepasswordForm';

export default function Changepassword() {

    useLayoutEffect(() => {
        document.body.style.background = `#fff url(${Background}) no-repeat center fixed`
        document.body.style.backgroundSize = `cover`
        document.body.style.width = '100%'
        document.body.style.height = '100vh'
        document.body.position = 'relative'
    });

    return (
        <div>
            <div className="flex justify-center items-center w-full h-screen">
                <div className="w-sm m-auto rounded-lg pb-12">
                    <div className="rounded-[7px]">
                        <>
                            <ChangepasswordForm />
                        </>
                    </div>
                </div>
            </div>
        </div>
    );
}
